import { Avatar, Button, ButtonGroup, Divider, Flex, Grid, GridItem, HStack, Spinner, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { Breadcrumb, Clipboard, Container, Dev, Icon, IconButton, Label, Pressable, Scope, Show, Tag } from "components";
import { Mask } from "config";
import { Moment } from "config";
import { useProduct } from "hooks";
import { useParams } from "react-router";
import Stocks from "./stocks";
import General from "./general";
import Options from "./options";
import Edit from "./edit";
import { useRef, useState } from "react";
import { API } from "config";

export default function Product(){

    const params = useParams()
    const product = useProduct(params?.id)

    const toast = useToast()
    const imageInputRef = useRef()
    const [ loading, setLoading ] = useState()

    const edit = useDisclosure()

    const handleChangeImage = async (e) => {
        const image = e.target?.files?.[0]
        if(!image) return

        setLoading(true)

        const form = new FormData()
        form.append('image', image)
        form.append('_method', 'put')

        try{
            await API.post(`/products/${product.data?.id}`, form, { headers: { "Content-Type": "multipart/form-data" } })
            toast({ title: 'Imagem do produto atualizada', status: 'success' })
            product.refetch()
        }catch(err){
            toast({ title: 'Não foi possível enviar a imagem. Tente novamente.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Container maxW="90%" mt={10}>

        <Grid templateColumns="50% 50%" alignItems="center">

            {/* Breadcrumbs */}
            <GridItem><Breadcrumb prev={{ path: '/products', label: 'Produtos' }} current="Perfil do produto" /></GridItem>

            {/* Actions */}
            <GridItem display="flex" justifyContent="flex-end">
                <ButtonGroup isDisabled={product.isFetching} size="xs">

                    {/* Permissão: manage_products */}
                    <Scope role="manage_products">
                        <Button children="Editar" leftIcon={<Icon name="edit" />} onClick={edit.onOpen} />
                    </Scope>

                    <IconButton isLoading={product.isFetching} onClick={product.refetch} icon="refresh" />

                    <Dev data={product.data} />
                </ButtonGroup>
            </GridItem>

        </Grid>

        <Divider my={4} />

        <Grid templateColumns="20% 80%">

            <GridItem>
                <Stack spacing={4}>

                    <Flex direction="column" alignItems="center" justifyContent="center">
                        <input type="file" accept="image/*" onChange={handleChangeImage} style={{ display: 'none' }} ref={imageInputRef} />
                        { loading ? <Spinner my={4} /> : <Pressable isDisabled={product.isFetching} label="Alterar imagem do produto" onClick={() => imageInputRef.current?.click()}><Avatar size="xl" name={product.data?.name} src={product.data?.image_url} mb={2} /></Pressable> }
                        <Text textAlign="center" textTransform="capitalize" fontSize="lg" children={product.data?.name} />
                        <Tag size="sm" children={product.data?.category?.name} />
                    </Flex>

                    <Divider />
                    <Label label="Tagline:" children={product.data?.tagline} />

                    <Divider />
                    <Label label="Valor de venda (R$):" fontWeight="bold" letterSpacing="-0.08rem" children={`R$ ${Mask.price(product.data?.price)}`} />
                    <Label label="Desconto para consultores (%):" fontWeight="bold" letterSpacing="-0.08rem" children={`${product.data?.wholesale_discount} %`} />
                    <Label label="Desconto para núcleos (%):" fontWeight="bold" letterSpacing="-0.08rem" children={`${product.data?.distributor_discount} %`} />
                    <Label label="Pontos gerados:" fontWeight="bold" letterSpacing="-0.08rem" children={`${parseFloat(product.data?.points/100 ?? 0).toFixed(2)} pontos`} />

                    <Divider />
                    <Label label="Fornecedor:" children={product.data?.supplier?.name} />

                    <Divider />
                    <Label label="ID:" fontSize="xs" children={<Clipboard children={product.data?.id} />} />
                    <Label label="Código (Legado):" fontSize="xs" children={<Clipboard children={product.data?.cod} />} />
                    <Label label="ID do Bling:" fontSize="xs" children={<Clipboard children={product.data?.bling_id} />} />

                    <Button isDisabled={!product.data?.bling_id} size="xs" children="Ver produto no Bling" />
                </Stack>
            </GridItem>

            <GridItem>

                {/* Tabs */}
                <Tabs isLazy size="sm" variant="enclosed" colorScheme="orange">
                    <TabList>
                        <Tab children="Visão Geral" />
                        <Tab children="Estoques" />
                        <Tab children="Opções" />
                    </TabList>

                    <TabPanels>
                        <TabPanel><General /></TabPanel>
                        <TabPanel><Stocks /></TabPanel>
                        <TabPanel><Options /></TabPanel>
                    </TabPanels>
                </Tabs>

            </GridItem>

        </Grid>

    </Container>

    <Edit {...edit} />
    </>
    )
}
